<template>
  <div class="d-flex flex-fill flex-column chart-report">
    <div class="d-flex">
      <div class="chart-report-label flex-grow-1">
        {{ settings.label || 'Value' }}
        <div v-if="settings.subLabel"
          ><small>{{ settings.subLabel }}</small></div
        >
      </div>
        <template v-if="!massiveActionLoading">
            <template v-for="(button, idx) in massiveActions">
                <button v-if="button.visible"  
                    :key="`btn-ma-${idx}`"
                    class="btn btn-default btn-sm mx-3"
                    :disabled="!toEdit || toEdit.length == 0 || massiveActionLoading"
                    @click="()=>executeMassiveAction(idx)">{{button.label}}
                </button>
            </template>
        </template>
        <v-progress-circular
            indeterminate
            color="primary"
            v-else
        ></v-progress-circular>
      <span v-if="!!exportSettings">
          <button
          v-if="!exportSettings.loading"
          class="btn btn-default btn-sm mx-3"
          @click="exportCallback()"
        >
          <v-icon class="mr-1" x-small>mdi-download</v-icon>Export
        </button>
        <v-progress-circular
          indeterminate
          color="primary"
          v-else
        ></v-progress-circular>
      </span>
    </div>
    <div
      v-if="settings.drillHistory && settings.drillHistory.length"
      class="m-2"
    >
      <span v-for="(dh, i) in settings.drillHistory" :key="i">
        <a href="javascript:void(0)" @click="changeHistory(dh.q, i)">{{
          dh.title
        }}</a>
        <span v-if="i != settings.drillHistory.length - 1" class="ml-2 mr-2"> 
          >
        </span>
      </span>
    </div>
    <div v-if="!!settings.error" class="ma-8">
      <div class="mb-2 text-center">
        {{ settings.label }} report can't be displayed due to the volume of data.
        <br />
        Click here to export the report.
      </div>
      <v-btn
        class="d-block"
        color="rgb(0, 62, 82)"
        dark
        elevation="0"
        rounded
        style="margin: auto"
        type="button"
        @click="exportCallback()"
      >
        Export
      </v-btn>
    </div>
    <div v-else-if="settings.response">
      <bw-table
        v-on="$listeners"
        class="overflow-x-hidden flex-grow-1 full-width table-max-width"
        :table-settings="tableSettings"
        :checked-columns="settings.checkedColumns"
        :column-options="settings.columnOptions"
        :partner="partner"
        :response="settings.response"
        @apply-data="tableApplyData"
        @update-per-page="filtersUpdate"
        ref="table"
        :editMode="selectable"
        :mass-edit-selections="toEdit"
        @selected-for-edit="toEdit = $event"
		:lastRowCheckable="settings.lastRowCheckable"
      >
      </bw-table>
    </div>
  </div>
</template>

<script>
import BwTable from '@components/TableComponents/BwTable'

export default {
  name: 'TableReport',
  components: {
    BwTable
  },
  props: {
    partner: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    exportSettings: {
      type: Object,
      required: false
    },
    massiveActions: {
        type: Array,
        required: false
    } 
  },
  data: () => {
    return {
        tableSettings: {},
        toEdit: [],
        currentPage: 1,
        itemsPerPage: 20,
        massiveActionLoading: false,
    }
  },
  methods: {
    filtersGetData() {},
    tableApplyData() {
      // tell parent filters to apply data
      // this.$refs.filters.applyData();
    },
    filtersUpdate(v) {
      // this.$refs.filters.updateFilters(v);
    },
    changeHistory(query, index) {
      this.$emit('change-history', { query, index })
    },
    exportCallback(response) {
      this.$emit('exp-callback', response)
    },
    async executeMassiveAction(key) {
        if (this.massiveActions[key].confirmMessage && !confirm(this.massiveActions[key].confirmMessage)) {
            return false;
        }
        this.massiveActionLoading = true;
        try {
            const result = await this.massiveActions[key].callback(this.toEdit);
            if (result && this.massiveActions[key].successMessage) {
                One.helpers('notify', {
                    align: 'center', type: 'success', icon: 'fa fa-check mr-1',
                    message: this.massiveActions[key].successMessage,
                });
            }
            this.toEdit = [];
            this.$emit('page-change', {page: this.currentPage, itemsPerPage: this.itemsPerPage });
            this.massiveActionLoading = false;
            return true;
        } catch (e) {
            const message = e?.responseJSON?.errorMessage || e?.responseJSON?.message || 'An error occurred while processing your request';
            One.helpers('notify', {align: 'center', type: 'danger', icon: 'fa fa-times mr-1', message});
        }
        this.massiveActionLoading = false;
    },
  },
  async mounted() {
      this.currentPage =  this.settings.response.current_page || 1;
      this.itemsPerPage=  this.settings.response.per_page || 20;
      this.$nextTick(() => {
          this.$on('selected-for-edit', toEdit => this.toEdit = toEdit);
      });
  },
  computed: {
      selectable() {
          return (this.massiveActions && this.massiveActions.filter(it => it.visible).length > 0) || this.settings.multiple;
      }
  }
}
</script>

<style lang="scss" scoped>
.table-max-width{
  margin: 0 auto;
  max-width: 80vw;
  @media(min-width: 960px){
    max-width: calc(100vw - 400px);
  }
  
}

.chart-report {
  background-color: white;
  min-height: 450px;
  border: 1px solid #ddd;
  margin: 8px;
  padding: 10px;
}
</style>
